

import { CommonTriggerPointType } from '../Enum/CommonTriggerPointType';
import { ChildDtmTriggerInfo } from './ChildTriggerInfo';
import { CommonOperation } from './CommonOperation';
import { ExecutingDataStatus } from './ExecutingDataStatus';
import { RequestChildElement } from './RequestChildElement';

/**
* 联动规则元数据定义
* @author wangjiegj<wangjiegj@inspur.com>
 */


/**
* 联动规则元数据定义
*
*/
export class CommonDetermination extends CommonOperation {
    constructor() {
        super();
    }

    /**
     * Node状态触发时机的类型
     */
    public GetExecutingDataStatus: ExecutingDataStatus;

    /**
     * 触发时变更集中需要包含的字段LabelID集合
     */
    public RequestElements: string[];

    public RequestChildElements: Map<string, string[]>;

    public TriggerPointType: CommonTriggerPointType;
    /**
     * 是否组织联动计算循环触发
     */
    public RunOnce: boolean;

    /**
 * 子表触发条件
 */
    public ChildTriggerInfo: ChildDtmTriggerInfo[];
    // /**
    //  * 操作类型
    //  */
    // get OpType() {
    //     return BEOperationType.Determination;
    // }

    // /**
    //  * Determination类型
    //  */
    // public DeterminationType: BEDeterminationType;

    // /**
    //  * 触发时机的类型
    //  */
    // public TriggerTimePointType: BETriggerTimePointType;

    // /**
    //  * 获取当前计算规则的前置计算规则
    //  * 根据元数据设计器上配置的计算顺序生成的当前计算规则的前置规则
    //  */
    // public PreDtmId: Map<BETriggerTimePointType, string>;

    // /**
    //  * 触发字段中是否包含某字段
    //  */
    // static countainRequestElement(dtm: CommonDetermination, id: string): boolean {
    //     if (this.countainEle(id, dtm.RequestElements)) {
    //         return true;
    //     }
    //     if (!!(dtm.RequestChildElements) && dtm.RequestChildElements.length > 0) {
    //         return this.countainEle(id, dtm.RequestChildElements[0].RequestChildElementValue);
    //     }
    //     return false;
    // }

    // private static countainEle(id: string, requestEles: string[]): boolean {
    //     if (!!(id) && !!(requestEles) && requestEles.length > 0) {
    //         return requestEles.includes(id);
    //     }
    //     return false;
    // }
}
